import React from 'react';
import $ from 'jquery'
import './ValuationPage.scss';

import CTABtnModule from '../../modules/cta_btn_module';
import ContentModule from "../../modules/content_module";

import {leadooPageSlot} from "../../common/constant";

const ValuationPage = ({Module, GQLPage}) =>{

  let pathname = GQLPage?.menu?.slug ? GQLPage?.menu?.slug.replace(/-/g, '_') : "";

  return(
  <>
    <div className={`valuation_wrapper ${Module?.valuation_box?.length > 1 ? "" : "full_wdth"}`}>
        {Module?.valuation_box?.length > 0 && Module?.valuation_box?.map((item, index) => {
            return(
                <div className={`valuation_box`}>
                    <h2>{item.title}</h2>
                    {item?.content && <ContentModule Content={item?.content} /> }
                    <CTABtnModule button_cta={item.button_cta[0]} />
                </div>
            )
        })}
    </div>

    {/* {leadooPageSlot?.sell_property && 
      <ld-slot name={leadooPageSlot[pathname]}></ld-slot>
    } */}
  </>
  )

}

export default ValuationPage